import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './successDialog.scss'

const SuccessDialog = ({ open, message, onClose }: any) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog className="dialog" open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>
        <Stack direction={"row"} className='dialogTitle' display={"flex"} alignItems={"center"}>
          <CheckCircleOutlineIcon fontSize="large" sx={{ color: 'success.main', mr: 1 }} />
          <Typography variant='h6'>Success</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography className='message' sx={{whiteSpace:'pre-line'}}>{message}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="close" onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
